import { c as _c } from "react/compiler-runtime";
export const PancakeLogo = t0 => {
  const $ = _c(12);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g clipPath="url(#clip0_8358_5223)"><rect fill="url(#paint0_linear_8358_5223)" height="44" width="44" /><path clipRule="evenodd" d="M21.9908 34.5887C18.29 34.5859 15.309 33.6979 13.2261 32.1028C11.1182 30.4886 10 28.1979 10 25.6059C10 23.1084 11.1158 21.3075 12.3782 20.0902C13.3676 19.1362 14.4594 18.5252 15.2197 18.1738C15.0478 17.6462 14.8333 16.9555 14.6414 16.2421C14.3846 15.2874 14.1327 14.1674 14.1327 13.3466C14.1327 12.3751 14.3445 11.3995 14.9156 10.6413C15.519 9.84039 16.4273 9.41132 17.5201 9.41132C18.3742 9.41132 19.0993 9.72808 19.6669 10.2746C20.2096 10.797 20.5707 11.4908 20.82 12.214C21.2582 13.4847 21.4288 15.0812 21.4767 16.6745H22.5234C22.5712 15.0812 22.7418 13.4847 23.18 12.214C23.4293 11.4908 23.7905 10.797 24.3331 10.2746C24.9008 9.72808 25.6258 9.41132 26.4799 9.41132C27.5727 9.41132 28.481 9.84039 29.0844 10.6413C29.6555 11.3995 29.8673 12.3751 29.8673 13.3466C29.8673 14.1674 29.6154 15.2874 29.3586 16.2421C29.1667 16.9555 28.9523 17.6462 28.7803 18.1738C29.5406 18.5252 30.6324 19.1362 31.6218 20.0902C32.8843 21.3075 34 23.1084 34 25.6059C34 28.1979 32.8818 30.4886 30.7739 32.1028C28.6911 33.6979 25.7101 34.5859 22.0093 34.5887H21.9908Z" fill="#633001" fillRule="evenodd" /><path d="M17.5201 10.3352C15.9195 10.3352 15.1827 11.5415 15.1827 13.2097C15.1827 14.5357 16.0388 17.1913 16.39 18.2251C16.469 18.4576 16.3449 18.7124 16.1185 18.8025C14.8357 19.3135 11.05 21.1844 11.05 25.4691C11.05 29.9825 14.8971 33.3856 21.9915 33.391C21.9943 33.391 21.9971 33.391 21.9999 33.391C22.0028 33.391 22.0056 33.391 22.0084 33.391C29.1027 33.3856 32.9498 29.9825 32.9498 25.4691C32.9498 21.1844 29.1642 19.3135 27.8814 18.8025C27.655 18.7124 27.5309 18.4576 27.6099 18.2251C27.9611 17.1913 28.8171 14.5357 28.8171 13.2097C28.8171 11.5415 28.0804 10.3352 26.4798 10.3352C24.1759 10.3352 23.6016 13.6321 23.5606 17.1705C23.5579 17.4068 23.3688 17.5984 23.135 17.5984H20.8649C20.631 17.5984 20.442 17.4068 20.4393 17.1705C20.3983 13.6321 19.824 10.3352 17.5201 10.3352Z" fill="#D1884F" /><path d="M22.0084 31.9452C16.7958 31.9452 11.059 29.1265 11.05 25.4776C11.05 25.4833 11.05 25.489 11.05 25.4947C11.05 30.0118 14.9033 33.4167 22.0084 33.4167C29.1135 33.4167 32.9667 30.0118 32.9667 25.4947C32.9667 25.489 32.9667 25.4833 32.9667 25.4776C32.9578 29.1265 27.221 31.9452 22.0084 31.9452Z" fill="#FEDC90" /><path d="M19.1122 24.3569C19.1122 25.5888 18.5358 26.2304 17.8249 26.2304C17.114 26.2304 16.5377 25.5888 16.5377 24.3569C16.5377 23.125 17.114 22.4834 17.8249 22.4834C18.5358 22.4834 19.1122 23.125 19.1122 24.3569Z" fill="#633001" /><path d="M27.4791 24.3569C27.4791 25.5888 26.9028 26.2304 26.1919 26.2304C25.481 26.2304 24.9047 25.5888 24.9047 24.3569C24.9047 23.125 25.481 22.4834 26.1919 22.4834C26.9028 22.4834 27.4791 23.125 27.4791 24.3569Z" fill="#633001" /></g>;
    t3 = <path d="M22 0.5C33.8741 0.5 43.5 10.1259 43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5Z" stroke="white" strokeOpacity="0.08" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_8358_5223" x1="22" x2="22" y1="0" y2="44"><stop stopColor="#53DEE9" /><stop offset="1" stopColor="#1FC7D4" /></linearGradient>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs>{t4}<clipPath id="clip0_8358_5223"><path d="M0 22C0 9.84974 9.84974 0 22 0V0C34.1503 0 44 9.84974 44 22V22C44 34.1503 34.1503 44 22 44V44C9.84974 44 0 34.1503 0 22V22Z" fill="white" /></clipPath></defs>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== className || $[9] !== rest || $[10] !== size) {
    t6 = <svg aria-label="Pancake Swap" className={className} fill="none" height={size} viewBox="0 0 44 44" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t2}{t3}{t5}</svg>;
    $[8] = className;
    $[9] = rest;
    $[10] = size;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};